import { render, staticRenderFns } from "./UserChEmail.vue?vue&type=template&id=1f2d48f4&scoped=true"
import script from "./UserChEmail.vue?vue&type=script&lang=js"
export * from "./UserChEmail.vue?vue&type=script&lang=js"
import style0 from "./UserChEmail.vue?vue&type=style&index=0&id=1f2d48f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d48f4",
  null
  
)

export default component.exports